var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37538_4687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.478 2.44385L5.39971 0.38497C4.31518 0.200099 3.28497 0.925895 3.094 2.00937L2.55371 5.07475L17.478 2.44385Z",
    fill: "rgba(0, 0, 0, 0.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.89835 8.78972L0.347221 17.5895C0.155462 18.6774 0.88197 19.7147 1.96986 19.9063L3.91849 20.2496L1.89835 8.78972Z",
    fill: "rgba(0, 0, 0, 0.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5237 9.23683C11.5827 9.23683 9.18945 11.6301 9.18945 14.571C9.18945 17.5122 11.5827 19.9055 14.5237 19.9055C17.4648 19.9055 19.8581 17.5122 19.8581 14.571C19.8581 11.6301 17.4646 9.23683 14.5237 9.23683ZM15.2858 18.3812H13.7617V16.8572H15.2858V18.3812ZM16.2935 14.4945C15.9065 14.967 15.5292 15.1336 15.288 15.2304C15.2866 15.258 15.2858 15.2923 15.2858 15.3332V16.0951H13.7617V15.3332C13.7617 14.3887 14.1315 14.0488 14.6875 13.8284C14.849 13.7643 14.9561 13.7226 15.114 13.5292C15.1927 13.4332 15.2858 13.2718 15.2858 13.047C15.2858 12.6265 14.9442 12.2849 14.5239 12.2849C14.1033 12.2849 13.7617 12.6265 13.7617 13.047H12.2377C12.2377 11.7864 13.2633 10.7609 14.5239 10.7609C15.7845 10.7609 16.8098 11.7864 16.8098 13.047C16.8098 13.5739 16.6267 14.0874 16.2935 14.4945Z",
    fill: "rgba(0, 0, 0, 0.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2546 7.03434C22.871 4.85874 20.7965 3.40598 18.6209 3.78949L6.98711 5.8403C4.81151 6.22381 3.35875 8.29838 3.74227 10.474L5.79307 22.1078C6.17659 24.2833 8.25116 25.7361 10.4268 25.3526L22.0605 23.3018C24.2361 22.9183 25.6889 20.8437 25.3054 18.6681L23.2546 7.03434ZM14.5238 21.4295C10.742 21.4295 7.66557 18.3531 7.66557 14.571C7.66557 10.7892 10.742 7.7128 14.5238 7.7128C18.3058 7.7128 21.3823 10.7892 21.3823 14.571C21.3823 18.3531 18.3058 21.4295 14.5238 21.4295Z",
    fill: "rgba(0, 0, 0, 0.38)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37538_4687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHow);
export default __webpack_public_path__ + "static/media/how.e1ef2850bb6c59c33fdd0162ad009ee7.svg";
export { ForwardRef as ReactComponent };